import { userSessionStore } from '../user-session-store'

function getUserId() {
  const session = userSessionStore.readUserSession()
  return session?.uid
}

export { getUserId }